import { render, staticRenderFns } from "./viewCustomFormApprovalProcess.vue?vue&type=template&id=741b4e7e&"
import script from "./viewCustomFormApprovalProcess.vue?vue&type=script&lang=js&"
export * from "./viewCustomFormApprovalProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSheet,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('741b4e7e')) {
      api.createRecord('741b4e7e', component.options)
    } else {
      api.reload('741b4e7e', component.options)
    }
    module.hot.accept("./viewCustomFormApprovalProcess.vue?vue&type=template&id=741b4e7e&", function () {
      api.rerender('741b4e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Approval/ApprovalProcess/viewCustomFormApprovalProcess.vue"
export default component.exports